<script setup lang="ts">
// EVENTS
const emit = defineEmits<{
    close: [];
}>();

// COMPOSABLES
// Owned by the modal body, which unmounts on close: every opening starts from an empty field.
const { inputValue, sellingMethod, isLoading, preview, onSubmit } = useQuickSearch({
    onClose: () => emit('close'),
});
</script>

<template>
    <QuickSearchPanel
        v-model="inputValue"
        v-model:selling-method="sellingMethod"
        :is-loading="isLoading"
        :preview="preview"
        :has-floating-preview="false"
        has-dismiss-hint
        has-autofocus
        @submit="onSubmit()"
        @navigate="emit('close')"
    />
</template>
